import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { Areas } from "../Areas/Areas";
import { Regiones } from "../Regiones";

const columns = () =>
(
    {
        c_region_id: new EntityColumn<string>({ name: 'c_region_id', type: 'char', length: 20, flags: c.PK, prompt: 'Region Id' }),
        c_area_id: new EntityColumn<string>({ name: 'c_area_id', type: 'char', length: 20, flags: c.PK, prompt: 'Area Id' }),
        c_subarea_id: new EntityColumn<string>({ name: 'c_subarea_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Subarea Id' }),
        vc_nombre_subarea: new EntityColumn<string>({ name: 'vc_nombre_subarea', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Nombre Subarea' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        suba_brwStandard: { name: 'suba_brwStandard', keyMappings: { c_subarea_id: 0 } }
    }
)

const lookups = () =>
(
    {
        'Areas': {
            name: 'Areas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Areas(client, parentKeys)
        },

        'Regiones': {
            name: 'Regiones',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Regiones(client, parentKeys)
        },

    }
)

export class SubAreasDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();

    constructor() {
        super('SubAreas');
    }
}